import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Date-only values from the API ("2026-08-05" — expected_delivery_date,
// ship_date, payment_due_date) are parsed by `new Date()` as UTC midnight,
// per the ES spec. Formatting that in the viewer's local zone then renders
// the PREVIOUS day anywhere west of UTC: a PO expected Aug 5 displayed as
// "Aug 4" in America/New_York.
//
// Full timestamps ("2026-07-02T21:15:34+00:00" — created_date) carry their
// own offset and are already correct, so they must keep going through the
// normal parse rather than being reinterpreted as local.
const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/

export function parseApiDate(iso: string): Date {
  const m = DATE_ONLY.exec(iso.trim())
  if (!m) return new Date(iso)
  // Local midnight — the calendar date the user picked, in their own zone.
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
}
